export function join(document, isDesktop) {
    if (isDesktop) {
        const imgTags = [...document.querySelectorAll(".join img")];
        let curImgTag = imgTags[0];

        function randomizer(arr, max) {
            return arr[Math.floor(Math.random() * max)];
        }

        setInterval(() => {
            const source = randomizer(images, images.length);
            const filteredImgTags = imgTags.filter(imgTagItem => imgTags.indexOf(imgTagItem) != imgTags.indexOf(curImgTag));
            const imgTag = curImgTag = randomizer(filteredImgTags, imgTags.length - 1);
            const filteredSources = images.filter(img => img != source);
            imgTag.style.opacity = "0";
            setTimeout(() => {
                imgTag.setAttribute("src", randomizer(filteredSources, filteredSources.length));
                imgTag.style.opacity = "1";
            }, 500);
        }, 3000);
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/join.js